<uikit-dropdown
	#dropdownComponent
	[propagation]="true"
>
	<ng-container drop>
		<button
			class="flex cursor-pointer appearance-none items-center gap-1.5 p-2 font-bold"
			[class.cursor-wait]="$loading()"
		>
			@if ($loading()) {
				<div class="h-6 w-6 animate-pulse rounded-full bg-surface-alt"></div>
				<div class="h-4 w-20 animate-pulse rounded-lg bg-surface-alt px-1"></div>
			} @else {
				<div
					class="flex h-6 w-6 items-center justify-center rounded-full"
					[class]="$isRemplacant() ? 'bg-surface-alt' : 'bg-warning-container'"
				>
					<cba-svg-centred-icon
						[name]="$fullClient() | fullClientIcon"
						[size]="16"
						[color]="$isRemplacant() ? 'fill-on-background-alt' : 'fill-on-warning-container'"
						[initiales]="$isRemplacant() ? ($fullClient() | fullClientInitiales) : null"
					/>
				</div>
				<span class="px-1 text-xs text-on-background-alt">{{ $fullClient() | fullClientName }}</span>
			}
		</button>
	</ng-container>
	<ng-container options>
		<cba-menu-profile-dropdown
			[fullClient]="$fullClient()"
			[loading]="$loading()"
			[droits]="$droits()"
			(close)="dropdownComponent.closeDropdown()"
		/>
	</ng-container>
</uikit-dropdown>
